import { ApiService } from '../../../shared/services/api.service';
import { Injectable } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable()
export class ConfigTabService {
  constructor(private apiService: ApiService) {
  }

  GetTabs() {
    return this.apiService.get('/api/mvp/dfb/get/tabs')
      .map(
      data => {
        return data;
      }
      );
  }

  AddTabs(agencyObj) {
    return this.apiService.post('/api/mvp/dfb/add/tab', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "error";
      }
      );
  }

  EditTab(agencyObj) {
    return this.apiService.post('/api/mvp/edit/dfbTab', agencyObj)
      .map(
      data => {
        return "Success";
      }
      ).catch(
      (error: Response) => {
        return "error";
      }
      );
  }
  GetSections() {
    return this.apiService.get('/api/mvp/dfb/get/getDFBSections')
      .map(
      data => {
        return data;
      }
      );
  }
    GetTabById(Id) {
    return this.apiService.get('/api/mvp/dfb/get/tab/Id/?tabId='+Id)
      .map(
      data => {
        return data;
      }
      );
  }
}





// WEBPACK FOOTER //
// ./src/app/system_setting/DFB/configure_tab/tab.service.ts